
  import * as imageProviderRuntime$FPtRI9XOM88Pmx8H_spLrT_45DRQ_45fv2PFG7mpJSZbknE from '/app/utils/imageProvider.ts'
  
  export const imageOptions = {
    ...{
  "screens": {
    "xs": 320,
    "sm": 640,
    "md": 768,
    "lg": 1024,
    "xl": 1280,
    "xxl": 1536,
    "2xl": 1536
  },
  "presets": {},
  "provider": "imageProvider",
  "domains": [],
  "alias": {},
  "densities": [
    1,
    2
  ],
  "format": [
    "webp"
  ]
},
    providers: {
        ['imageProvider']: { provider: imageProviderRuntime$FPtRI9XOM88Pmx8H_spLrT_45DRQ_45fv2PFG7mpJSZbknE, defaults: undefined }
    }
  }
